export function formatMatchDate(isoString) {
  if (!isoString) return '—';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '—';
  const datePart = date.toLocaleDateString('ru-RU', {day: 'numeric', month: 'long'});
  const time = date.toLocaleTimeString('ru-RU', {hour: '2-digit', minute: '2-digit'});
  return `${datePart} ${time}`;
}
